import type { InterferenciaFCA } from "@/types/fca";

interface Props {
  interferencias: InterferenciaFCA[];
}

const intensidadeBadge: Record<string, string> = {
  "Baixa": "bg-primary-100 text-primary-700",
  "Média": "bg-caution-100 text-caution-700",
  "Alta": "bg-warning-100 text-warning-700",
  "Crítica": "bg-danger-100 text-danger-700",
};

export default function TreeInterferenceList({ interferencias }: Props) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground-900 font-heading mb-4 flex items-center gap-2">
        <i className="ri-building-line text-warning-500"></i>
        Interferências Identificadas
      </h3>

      {interferencias.length === 0 ? (
        <div className="text-center py-8 text-foreground-500 text-sm bg-white rounded-card border border-background-200/70">
          <i className="ri-check-line text-3xl block mb-2 text-primary-500 opacity-50"></i>
          Nenhuma interferência identificada
        </div>
      ) : (
        <div className="space-y-3">
          {interferencias.map((int) => (
            <div key={int.id} className="bg-white rounded-card border border-background-200/70 p-4">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-2.5">
                  <span className="w-8 h-8 rounded-md bg-warning-50 flex items-center justify-center shrink-0">
                    <i className="ri-alert-line text-warning-600 text-sm"></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{int.tipo}</p>
                  </div>
                </div>
                <span className={`badge ${intensidadeBadge[int.intensidade] || "bg-background-100 text-foreground-500"}`}>
                  {int.intensidade}
                </span>
              </div>
              <p className="text-sm text-foreground-600 mb-2 ml-10">{int.descricao}</p>
              <div className="ml-10 flex items-center gap-3 text-xs text-foreground-500">
                {int.fotoVinculada && (
                  <span className="flex items-center gap-1">
                    <i className="ri-camera-line"></i>
                    Foto vinculada: {int.fotoVinculada}
                  </span>
                )}
              </div>
              <div className="ml-10 mt-2 pt-2 border-t border-background-100">
                <p className="text-xs text-primary-700 font-medium flex items-center gap-1">
                  <i className="ri-lightbulb-line"></i>
                  {int.recomendacao}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}